export default __webpack_public_path__ + "static/media/6.eb78b15c.png";